import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types';
// import Plyr from "plyr";
import { bookVideoFromRawIdMp4Fallback, retrieveLocally, saveLocally } from '../../lib/utils';
import { Modal, notification } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getIsPremiumUser } from '../../lib/fileUtils';
import { colors } from '../../lib/theme';
// import { useRef } from "react";

export default class VideoThumbnail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            showVideo: false,
        };
        this.videoRef = createRef();
        this.player = null;
    }

    openModal = () => {
        const { userDetails } = this.props;
        if (!userDetails || !userDetails.uid) {
            notification.info(
                {
                    duration: 0,
                    message: 'Please sign in or register to continue.'
                });
            return;
        }
        if (!getIsPremiumUser()) {
            // final SharedPreferences prefs = await SharedPreferences.getInstance();
            const videoWatchCount = retrieveLocally('VIDEO_WATCH_COUNT') ?? 0;

            if (videoWatchCount > 0) {
                notification.info(
                    {
                        duration: 0,
                        message: 'Please move to premium to watch more videos.'
                    });
                return;
            }
            saveLocally('VIDEO_WATCH_COUNT', videoWatchCount + 1, 24 * 30);
        }

        this.setState({ isModalOpen: true }, () => {
            setTimeout(() => {
                this.playFullscreenVideoMain();
                // this.player?.play(); // Auto-play after modal opens
            }, 300);
        });
    };

    closeModal = () => {
        console.dir('closeModal');
        console.dir('closeModal1');
        this.player.stop(); // Pause video when modal closes
        console.dir('closeModal2');
        // this.player = null;
        this.setState({ showVideo: false });
        this.setState({ isModalOpen: false }, () => {
        });
    };

    playFullscreenVideoMain = async () => {
        if (this.player == null) {
            await this.initPlyr();
        }
        await this.playFullscreenVideo();

        // const video = this.videoRef.current;
        // if (video) {
        //     video.play();
        //     if (video.requestFullscreen) {
        //         video.requestFullscreen();
        //     } else if (video.webkitRequestFullscreen) {
        //         video.webkitRequestFullscreen();
        //     } else if (video.msRequestFullscreen) {
        //         video.msRequestFullscreen();
        //     }
        // }
    };

    initPlyr = async () => {
        const { thumbnailUrl, videoUrl } = this.props;
        const video = this.videoRef.current;
        const hlsUrl = videoUrl; // Replace with your HLS video source
        const mp4Url = bookVideoFromRawIdMp4Fallback(videoUrl); // MP4 fallback

        // Check if the browser supports native HLS
        if (video.canPlayType("application/vnd.apple.mpegurl")) {
            video.src = hlsUrl;
        } else {
            video.src = mp4Url; // Fallback to MP4
        }
        console.dir('init plyr');

        // Initialize Plyr
        const Plyr = (await import('plyr')).default;
        if (this.player == null) {
            this.player = new Plyr(video, {
                controls: ["play", "progress", "current-time", "mute", "fullscreen"],
            });
        }
    };

    playFullscreenVideo = async () => {
        const video = this.videoRef.current;
        if (this.player) {
            await this.player.play(); // Start playing
            this.setState({ showVideo: true });

            // // Ensure fullscreen works across browsers
            // if (document.fullscreenEnabled || document.webkitFullscreenEnabled) {
            //     if (video.requestFullscreen) {
            //         await video.requestFullscreen();
            //     } else if (video.webkitRequestFullscreen) {
            //         await video.webkitRequestFullscreen();
            //     } else if (video.msRequestFullscreen) {
            //         await video.msRequestFullscreen();
            //     }
            // }
        }
    };

    render() {
        const { thumbnailUrl, videoUrl, maxWidth } = this.props;
        const { showVideo } = this.state;
        console.dir(thumbnailUrl);
        console.dir(videoUrl);
        // return (<></>)
        return (
            <div className="flex flex-col items-center">
                {/* Thumbnail */}
                <div style={{ position: 'relative' }} onClick={this.openModal}>
                    <img
                        src={thumbnailUrl} // Replace with your thumbnail
                        alt="Video Thumbnail"
                        className="w-64 h-36 cursor-pointer"
                    />
                    <div className='play-icon'>
                        <FontAwesomeIcon style={{ marginLeft: '4px', fontSize: `32px`, color: colors.secondary }} icon='play-circle' />
                    </div>
                </div>

                {/* Fullscreen Modal */}
                <Modal
                    open={this.state.isModalOpen}
                    onCancel={this.closeModal}
                    footer={null}
                    centered
                    width="100vw"
                    className='video-modal'
                    bodyStyle={{
                        backgroundColor: "rgba(0, 0, 0, 0.8)", // Semi-transparent background
                        padding: 0,
                        height: "100vh", // Full screen height
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div className="flex justify-center items-center w-full h-full">
                        <video ref={this.videoRef}
                            className='hidden'
                            style={{
                                objectFit: "contain", // Prevents overflow, keeps aspect ratio
                                maxWidth: "100vw", // Ensures video doesn’t exceed screen width
                                // width: "56.25vh",
                                height: "100vh", // Ensures video doesn’t exceed screen height
                                maxHeight: "100vh", // Ensures video doesn’t exceed screen height
                            }}
                            playsInline controls />
                    </div>
                </Modal>

                {/* Hidden Video */}
                {/* <video ref={this.videoRef} className="hidden" playsInline controls /> */}
                {/* <video
                    ref={this.videoRef}
                    className="hidden"
                    controls
                    preload="none"
                >
                    <source src={videoUrl} type="application/x-mpegURL" />
                </video> */}

                <style jsx>
                    {
                        `

                    :global(.ant-modal-wrap:has(.video-modal)) {
                        z-index: 100000;
                    }
                    .hidden {
                        display: ${showVideo ? 'block' : 'none'};
                    }
                    img {
                        max-width: ${maxWidth || '200px'};
                        cursor: pointer;
                    }
                        :global(.video-modal .ant-modal-body) {
                        background-color: rgba(0, 0, 0, 1) !important;
                        border-radius: 0 !important;
                        }
                        :global(.video-modal .ant-modal-close) {
                        color: white !important;
                        }
                        .play-icon {
                        position: absolute;
                        bottom: 2px;
                        left: 4px;
                        cursor: pointer;
                        }
                `
                    }
                </style>
            </div>
        );

    }
}

VideoThumbnail.propTypes = {
    videoUrl: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    maxWidth: PropTypes.string,
    userDetails: PropTypes.object
}